/**
 * 用于在 VS Code 给没有直接包裹在 `t('')` 的字段使用，可以搭配 i18n Ally 显示实际的翻译
 * 在需要在配置中加入 "i18n-ally.regex.usageMatchAppend": ["[^\\w\\d]tkey\\(['\"`]({key})['\"`]"],
 */
export const tkey = <T extends string>(key: T): T => key;
